import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OcrValidationComponent } from './ocr-validation.component';

const routes: Routes = [
  {
    path: '',
    component: OcrValidationComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OcrValidationRoutingModule {}
